// extracted by mini-css-extract-plugin
export default {"featuredDestinations":"social-skeletons-FeaturedDestinationsLoadingSkeleton__featuredDestinations--3T9m0","list":"social-skeletons-FeaturedDestinationsLoadingSkeleton__list--fVWTM"};